import {
  filterRelevantGrades,
  getDefaultGrade,
  sortGradesDesc,
} from 'src/utils/grades.utils';
import { pipe } from 'src/utils/pipe';

import { AllEnrollmentResponse, GradesMESResponse } from './types';

const arrangeEntrywaysUserGrades = pipe(
  filterRelevantGrades,
  sortGradesDesc,
  getDefaultGrade,
);

export const normalizeEntrywaysGradesResponse = (
  data: AllEnrollmentResponse,
): GradesMESResponse => {
  try {
    const dataObj = data.getAllEnrollment_v2;

    if (!dataObj) return null;

    const schools = dataObj.districts.flatMap(
      (district) => district.schools || [],
    );
    const grades = schools
      .flatMap((school) => school.studentsByGrade)
      .map((gradeObj) => gradeObj.grade);
    const uniqueGrades = [...new Set(grades)];

    // Return null if no grades found to avoid adding default grade
    if (uniqueGrades.length === 0) return null;

    return arrangeEntrywaysUserGrades({ grades: uniqueGrades });
  } catch (error) {
    console.error('mES enrollment data normalization failed:', error);
    return null; // Return null instead of crashing UI
  }
};
